<template>
  <v-app
    id="app"
    data-test="app"
    :style="appStyles"
    @click="$auth.bodyClicked && $auth.bodyClicked()"
  >
    <dialog-navigator isVDialog dark/>

    <side-nav/>

    <router-view
      :key="$route.path"
    />

    <snackbar-messages
      messageOnlyColor="white"
    />
  </v-app>
</template>

<script>
import {
  DialogNavigator,
  SnackbarMessages
} from "vue-app-components";
import SideNav from "@/components/side-nav.vue";
import SwUpdateMixin from "@/utils/sw-update-mixin";

export default {
  mixins: [SwUpdateMixin],
  components: {
    DialogNavigator,
    SnackbarMessages,
    SideNav
  },
  inject: ["$auth"],
  data () {
    return {};
  },
  computed: {
    appStyles () {
      return {
        "--primary-color": this.$vuetify.theme.current.colors.primary,
        "--primary-color-lighten1": this.$vuetify.theme.current.colors.primaryLight,
        "--secondary-color": this.$vuetify.theme.current.colors.secondary,
        "--accent-color": this.$vuetify.theme.current.colors.accent,
        "--background-color": "#f5f5f5"
      };
    }
  }
};

</script>